import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "~/hooks/reduxHooks";
import { getFlatPageMapping } from "~/locationMaps";
import { updateActionLinks } from "~/store/layoutSlice";

// regex match return first match
const getActionLinks = (path: string, flatPageMapping: { [key: string]: PageMapping }) => {
	const match = Object.keys(flatPageMapping).find((key) => {
		return new RegExp(key + "$").test(path);
	});
	return match && flatPageMapping[match] ? flatPageMapping[match].actions : [];
};

const useActionMenu = (): void => {
	const dispatch = useAppDispatch();
	const location = useLocation();
	const application = useAppSelector((state) => state.layout.application);
	const flatPageMapping = useMemo(() => getFlatPageMapping(application), [application]);
	useEffect(() => {
		const path = location.pathname;
		const actionLinks = getActionLinks(path, flatPageMapping);
		dispatch(updateActionLinks(actionLinks));
	}, [location.pathname, flatPageMapping]);
};

export default useActionMenu;
